// File: src/pages/student/PersonalityTestPage.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import logoImg from '../../assets/avt.png';

// --- ICONS ---
const IconBrain = () => <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="text-white"><path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3A2.5 2.5 0 0 1 9.5 2Z"/><path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 14.5 2Z"/></svg>;
const IconArrowLeft = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m12 19-7-7 7-7"/><path d="M19 12H5"/></svg>;
const IconArrowRight = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>;

// --- DATA: 16 NHÓM TÍNH CÁCH (Cho Slider) ---
const MBTI_LIST = [
    { code: 'ISTJ', name: 'Người Trách Nhiệm', color: '#EF4444', desc: 'Thực tế, coi trọng sự thật.', img: '👮' },
    { code: 'ISFJ', name: 'Người Nuôi Dưỡng', color: '#F97316', desc: 'Tận tâm và ấm áp.', img: '👩‍⚕️' },
    { code: 'INFJ', name: 'Người Che Chở', color: '#10B981', desc: 'Sâu sắc và đầy cảm hứng.', img: '🧘' },
    { code: 'INTJ', name: 'Nhà Kiến Tạo', color: '#3B82F6', desc: 'Tư duy chiến lược độc lập.', img: '♟️' },
    { code: 'ISTP', name: 'Nhà Kỹ Thuật', color: '#EF4444', desc: 'Táo bạo và thực tế.', img: '🔧' },
    { code: 'ISFP', name: 'Người Nghệ Sĩ', color: '#F97316', desc: 'Linh hoạt và quyến rũ.', img: '🎨' },
    { code: 'INFP', name: 'Người Lý Tưởng', color: '#10B981', desc: 'Tốt bụng và vị tha.', img: '🧚' },
    { code: 'INTP', name: 'Nhà Tư Duy', color: '#3B82F6', desc: 'Sáng tạo và khao khát kiến thức.', img: '🧪' },
    { code: 'ESTP', name: 'Người Thực Thi', color: '#EF4444', desc: 'Thông minh và năng động.', img: '🚀' },
    { code: 'ESFP', name: 'Người Trình Diễn', color: '#F97316', desc: 'Nhiệt tình và ngẫu hứng.', img: '💃' },
    { code: 'ENFP', name: 'Người Truyền Cảm Hứng', color: '#10B981', desc: 'Sáng tạo và hòa đồng.', img: '🤹' },
    { code: 'ENTP', name: 'Người Tranh Biện', color: '#3B82F6', desc: 'Thông minh và tò mò.', img: '🗣️' },
    { code: 'ESTJ', name: 'Người Giám Sát', color: '#EF4444', desc: 'Quản lý sự việc tuyệt vời.', img: '📋' },
    { code: 'ESFJ', name: 'Người Chăm Sóc', color: '#F97316', desc: 'Tận tụy và nổi tiếng.', img: '🤝' },
    { code: 'ENFJ', name: 'Người Chỉ Dẫn', color: '#10B981', desc: 'Thu hút và truyền cảm hứng.', img: '🎤' },
    { code: 'ENTJ', name: 'Nhà Điều Hành', color: '#3B82F6', desc: 'Lãnh đạo táo bạo.', img: '💼' }
];

const MBTI_DIMENSIONS = [
    { code: 'E vs I', title: 'Năng Lượng', desc: 'Cách bạn tương tác với thế giới.', left: 'Extrovert (Hướng ngoại)', right: 'Introvert (Hướng nội)', color: 'from-orange-400 to-red-500' },
    { code: 'S vs N', title: 'Nhận Thức', desc: 'Cách bạn tiếp nhận thông tin.', left: 'Sensing (Cảm giác)', right: 'Intuition (Trực giác)', color: 'from-blue-400 to-cyan-500' },
    { code: 'T vs F', title: 'Quyết Định', desc: 'Cách bạn đưa ra lựa chọn.', left: 'Thinking (Lý trí)', right: 'Feeling (Cảm xúc)', color: 'from-purple-400 to-pink-500' },
    { code: 'J vs P', title: 'Lối Sống', desc: 'Cách bạn tổ chức cuộc sống.', left: 'Judging (Nguyên tắc)', right: 'Perceiving (Linh hoạt)', color: 'from-green-400 to-emerald-500' }
];

export default function PersonalityTestPage() {
    const navigate = useNavigate();
    const [viewState, setViewState] = useState('intro'); // intro | quiz | processing | result
    const [questions, setQuestions] = useState([]);
    const [currentQIndex, setCurrentQIndex] = useState(0);
    const [answers, setAnswers] = useState({}); 
    const [finalResult, setFinalResult] = useState(null);
    const quizRef = useRef(null);
    
    // --- SLIDER LOGIC ---
    const sliderRef = useRef(null);
    const autoScrollRef = useRef(null);

    const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

    // Hàm scroll thủ công
    const scrollSlider = (direction) => {
        if (sliderRef.current) {
            const { current } = sliderRef;
            const scrollAmount = 300; // Chiều rộng card + gap
            current.scrollBy({ left: direction === 'left' ? -scrollAmount : scrollAmount, behavior: 'smooth' });
        }
    };

    // Hàm bắt đầu auto scroll
    const startAutoScroll = () => {
        stopAutoScroll(); // Clear interval cũ nếu có
        autoScrollRef.current = setInterval(() => {
            if (sliderRef.current) {
                const { scrollLeft, scrollWidth, clientWidth } = sliderRef.current;
                const isEnd = scrollLeft + clientWidth >= scrollWidth - 10; // -10 là sai số
                
                if (isEnd) {
                    // Nếu hết đường thì quay về đầu
                    sliderRef.current.scrollTo({ left: 0, behavior: 'smooth' });
                } else {
                    // Chưa hết thì đi tiếp 1 card
                    sliderRef.current.scrollBy({ left: 300, behavior: 'smooth' });
                }
            }
        }, 3000); // 3 giây chạy 1 lần
    };

    // Hàm dừng auto scroll
    const stopAutoScroll = () => {
        if (autoScrollRef.current) {
            clearInterval(autoScrollRef.current);
        }
    };

    // Chạy auto scroll khi component mount
    useEffect(() => {
        if (viewState === 'intro') {
            startAutoScroll();
        }
        return () => stopAutoScroll(); // Cleanup khi unmount
    }, [viewState]);

    // 1. Start Test
    const startTest = async () => {
        setViewState('processing');
        try {
            const token = localStorage.getItem('skillmatch_token');
            if (!token) return navigate('/login');

            const res = await fetch(`${API_URL}/api/student/mbti-test`, {
                headers: { 'x-auth-token': token }
            });
            const data = await res.json();
            
            if (Array.isArray(data) && data.length > 0) {
                setQuestions(data);
                setViewState('quiz');
                setTimeout(() => quizRef.current?.scrollIntoView({ behavior: 'smooth' }), 100);
            } else {
                alert("Hệ thống đang bận, dùng câu hỏi mẫu.");
                setViewState('intro');
            }
        } catch (err) {
            console.error(err);
            setViewState('intro');
        }
    };

    // 2. Handle Answer
    const handleAnswer = (val) => {
        const q = questions[currentQIndex];
        setAnswers(prev => ({ ...prev, [q.id]: val }));

        if (currentQIndex < questions.length - 1) {
            setTimeout(() => setCurrentQIndex(prev => prev + 1), 250);
        } else {
            submitTest({ ...answers, [q.id]: val });
        }
    };

    // 3. Submit
    const submitTest = async (finalAnswers) => {
        setViewState('processing');
        let scores = { E: 0, I: 0, S: 0, N: 0, T: 0, F: 0, J: 0, P: 0 };
        questions.forEach(q => {
            const val = finalAnswers[q.id];
            if (scores[val] !== undefined) scores[val]++;
        });

        const mbtiCode = [
            scores.E >= scores.I ? 'E' : 'I',
            scores.S >= scores.N ? 'S' : 'N',
            scores.T >= scores.F ? 'T' : 'F',
            scores.J >= scores.P ? 'J' : 'P'
        ].join('');

        try {
            const token = localStorage.getItem('skillmatch_token');
            const res = await fetch(`${API_URL}/api/student/mbti-result`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
                body: JSON.stringify({ mbtiCode })
            });
            const analysis = await res.json();
            setFinalResult({ code: mbtiCode, ...analysis });
            setViewState('result');
        } catch (err) {
            console.error(err);
            alert("Lỗi phân tích kết quả.");
        }
    };

    return (
        <div className="student-page-container">
            {/* BACKGROUND */}
            <div className="blob blob-1"></div>
            <div className="blob blob-2"></div>

            {/* NAV BACK */}
            <div className="top-nav">
                <button className="back-btn-modern" onClick={() => navigate('/student')}>
                    <div className="icon-circle"><IconArrowLeft /></div>
                    <span>Dashboard</span>
                </button>
            </div>

            <div className="content-wrapper">
                
                {/* --- STATE 1: INTRO --- */}
                {viewState === 'intro' && (
                    <div className="intro-container animate-fade-up">
                        {/* Hero Banner */}
                        <div className="glass-card hero-card text-center p-12 mb-12">
                            <div className="flex justify-center mb-6">
                                <img
                                    src={logoImg}
                                    alt="SkillMatch Logo"
                                    className="h-24 w-auto object-contain drop-shadow-md hover:scale-105 transition-transform"
                                />
                            </div>
                            <h1 className="student-title text-4xl md:text-5xl mb-4">
                                Khám phá bản thân với <br/><span className="highlight">AI MBTI Test</span>
                            </h1>
                            <p className="student-subtitle max-w-2xl mx-auto mb-8">
                                Trải nghiệm bài trắc nghiệm tính cách được AI thiết kế riêng cho bạn. 
                                Hiểu rõ điểm mạnh, điểm yếu và tìm ra lộ trình sự nghiệp hoàn hảo.
                            </p>
                            <button className="btn-magic text-lg px-12 py-4" onClick={startTest}>
                                Bắt đầu khám phá ngay 🚀
                            </button>
                        </div>

                        {/* --- NEW: 16 NHÓM TÍNH CÁCH SLIDER (AUTO SCROLL) --- */}
                        <div className="mb-16">
                            <div className="flex justify-between items-end mb-6 px-2">
                                <div>
                                    <h3 className="text-2xl font-black text-gray-800">16 Nhóm Tính Cách MBTI</h3>
                                    <p className="text-gray-500 text-sm mt-1">Tìm hiểu sơ lược về các nhóm tính cách phổ biến</p>
                                </div>
                                <div className="flex gap-2">
                                    <button onClick={() => scrollSlider('left')} className="p-2 rounded-full bg-white border hover:bg-gray-50"><IconArrowLeft /></button>
                                    <button onClick={() => scrollSlider('right')} className="p-2 rounded-full bg-white border hover:bg-gray-50 transform rotate-180"><IconArrowLeft /></button>
                                </div>
                            </div>
                            
                            {/* Container: MouseEnter -> Stop, MouseLeave -> Start */}
                            <div 
                                className="slider-container" 
                                ref={sliderRef}
                                onMouseEnter={stopAutoScroll} 
                                onMouseLeave={startAutoScroll}
                            >
                                {MBTI_LIST.map((item, idx) => (
                                    <div key={idx} className="slider-card glass-card">
                                        <div className="text-4xl mb-4">{item.img}</div>
                                        <h2 className="text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-purple-600 mb-1">{item.code}</h2>
                                        <h4 className="font-bold text-gray-800 mb-2">{item.name}</h4>
                                        <p className="text-sm text-gray-500 line-clamp-3">{item.desc}</p>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* 4 Nhóm Tính Cách (Cards) */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16">
                            {MBTI_DIMENSIONS.map((item, idx) => (
                                <div key={idx} className="glass-card p-6 border-l-4 border-transparent hover:border-l-pink-500 transition-all">
                                    <div className={`h-2 w-12 rounded-full mb-4 bg-gradient-to-r ${item.color}`}></div>
                                    <h3 className="text-xl font-bold text-gray-800 mb-2">{item.code} - {item.title}</h3>
                                    <p className="text-gray-500 text-sm mb-4">{item.desc}</p>
                                    <div className="flex justify-between text-xs font-semibold text-gray-600 bg-gray-50 p-3 rounded-xl">
                                        <span>{item.left}</span>
                                        <span>⚡</span>
                                        <span>{item.right}</span>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Hướng dẫn */}
                        <div className="bg-white/80 rounded-3xl p-8 border border-white shadow-sm mb-16">
                            <h3 className="text-xl font-bold text-gray-800 mb-6 text-center">💡 Để có kết quả chính xác nhất</h3>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
                                <div>
                                    <div className="text-4xl mb-3">🧘</div>
                                    <h4 className="font-bold text-gray-700">Tâm lý thoải mái</h4>
                                    <p className="text-sm text-gray-500">Hãy làm bài khi bạn đang trong trạng thái bình ổn nhất.</p>
                                </div>
                                <div>
                                    <div className="text-4xl mb-3">⚡</div>
                                    <h4 className="font-bold text-gray-700">Phản xạ nhanh</h4>
                                    <p className="text-sm text-gray-500">Chọn đáp án đầu tiên nảy ra trong đầu bạn.</p>
                                </div>
                                <div>
                                    <div className="text-4xl mb-3">🤝</div>
                                    <h4 className="font-bold text-gray-700">Trung thực</h4>
                                    <p className="text-sm text-gray-500">Chọn điều bạn thực sự là, không phải điều bạn muốn trở thành.</p>
                                </div>
                            </div>
                        </div>

                        {/* --- NEW: THÔNG TIN BỔ ÍCH --- */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-20">
                            <div className="glass-card p-8">
                                <h3 className="text-xl font-bold text-gray-800 mb-4">Tại sao nên làm MBTI?</h3>
                                <ul className="space-y-4 text-gray-600">
                                    <li className="flex gap-3">
                                        <span className="text-green-500 font-bold">✓</span>
                                        Hiểu rõ điểm mạnh để phát huy, điểm yếu để khắc phục.
                                    </li>
                                    <li className="flex gap-3">
                                        <span className="text-green-500 font-bold">✓</span>
                                        Xác định môi trường làm việc phù hợp với tính cách.
                                    </li>
                                    <li className="flex gap-3">
                                        <span className="text-green-500 font-bold">✓</span>
                                        Cải thiện kỹ năng giao tiếp và thấu hiểu người khác.
                                    </li>
                                </ul>
                            </div>
                            <div className="glass-card p-8">
                                <h3 className="text-xl font-bold text-gray-800 mb-4">Ứng dụng trong tuyển dụng</h3>
                                <p className="text-gray-600 mb-4">
                                    Nhiều tập đoàn lớn (Vingroup, FPT, Unilever...) sử dụng MBTI để đánh giá mức độ phù hợp văn hóa (Culture Fit) của ứng viên.
                                </p>
                                <div className="bg-pink-50 p-4 rounded-xl text-pink-700 text-sm font-semibold">
                                    💡 Mẹo: Hãy thêm kết quả MBTI vào CV của bạn trên SkillMatch để gây ấn tượng với nhà tuyển dụng!
                                </div>
                            </div>
                        </div>

                    </div>
                )}

                {/* --- STATE 2: LOADING --- */}
                {viewState === 'processing' && (
                    <div className="h-[60vh] flex flex-col items-center justify-center text-center">
                        <div className="spinner-lg mb-6"></div>
                        <h2 className="text-2xl font-bold text-gray-800">AI đang làm việc...</h2>
                        <p className="text-gray-500">Đang phân tích dữ liệu thần kinh học của bạn 🧠</p>
                    </div>
                )}

                {/* --- STATE 3: QUIZ --- */}
                {viewState === 'quiz' && questions.length > 0 && (
                    <div ref={quizRef} className="max-w-2xl mx-auto py-10 animate-fade-in">
                        <div className="glass-card p-8 md:p-12 relative overflow-hidden">
                            <div className="absolute top-0 left-0 w-full h-2 bg-gray-100">
                                <div 
                                    className="h-full bg-gradient-to-r from-pink-500 to-purple-600 transition-all duration-300"
                                    style={{ width: `${((currentQIndex + 1) / questions.length) * 100}%` }}
                                ></div>
                            </div>
                            <div className="mb-8 mt-4 flex justify-between items-end">
                                <span className="text-sm font-bold text-gray-400 uppercase tracking-widest">Câu hỏi {currentQIndex + 1}/{questions.length}</span>
                                <span className="text-xs font-bold px-3 py-1 bg-pink-100 text-pink-600 rounded-full">
                                    Nhóm {questions[currentQIndex].dimension}
                                </span>
                            </div>
                            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-10 leading-relaxed">
                                {questions[currentQIndex].question}
                            </h2>
                            <div className="space-y-4">
                                {questions[currentQIndex].options.map((opt, idx) => (
                                    <button
                                        key={idx}
                                        onClick={() => handleAnswer(opt.value)}
                                        className="w-full text-left p-6 rounded-2xl border-2 border-gray-100 hover:border-pink-500 hover:bg-pink-50/50 transition-all duration-200 group"
                                    >
                                        <div className="flex items-center gap-4">
                                            <div className="w-8 h-8 rounded-full border-2 border-gray-300 group-hover:border-pink-500 flex items-center justify-center text-gray-400 group-hover:text-pink-500 font-bold text-sm">
                                                {idx === 0 ? 'A' : 'B'}
                                            </div>
                                            <span className="text-lg text-gray-700 font-medium group-hover:text-gray-900">
                                                {opt.text}
                                            </span>
                                        </div>
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                )}

                {/* --- STATE 4: RESULT --- */}
                {viewState === 'result' && finalResult && (
                    <div className="result-container animate-fade-up max-w-4xl mx-auto">
                        <div className="glass-card p-10 text-center mb-10 overflow-hidden relative">
                            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500"></div>
                            
                            <h3 className="text-gray-500 font-bold uppercase tracking-widest mb-4">Nhóm tính cách của bạn</h3>
                            <h1 className="text-6xl md:text-8xl font-black text-transparent bg-clip-text bg-gradient-to-r from-pink-600 to-purple-600 mb-2">
                                {finalResult.code}
                            </h1>
                            <h2 className="text-3xl font-bold text-gray-800 mb-6">{finalResult.title}</h2>
                            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl mx-auto mb-8">
                                {finalResult.overview}
                            </p>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-left mt-10">
                                <div className="bg-green-50 p-6 rounded-2xl border border-green-100">
                                    <h4 className="font-bold text-green-700 mb-4 flex items-center gap-2">
                                        <span className="text-2xl">💪</span> Điểm mạnh
                                    </h4>
                                    <ul className="space-y-2">
                                        {finalResult.strengths?.map((s, i) => (
                                            <li key={i} className="flex gap-2 text-gray-700 text-sm">
                                                <span className="text-green-500">✓</span> {s}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="bg-red-50 p-6 rounded-2xl border border-red-100">
                                    <h4 className="font-bold text-red-700 mb-4 flex items-center gap-2">
                                        <span className="text-2xl">⚠️</span> Điểm cần khắc phục
                                    </h4>
                                    <ul className="space-y-2">
                                        {finalResult.weaknesses?.map((w, i) => (
                                            <li key={i} className="flex gap-2 text-gray-700 text-sm">
                                                <span className="text-red-400">•</span> {w}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>

                            <div className="mt-8 pt-8 border-t border-gray-100">
                                <h4 className="font-bold text-gray-800 mb-4">🚀 Nghề nghiệp phù hợp</h4>
                                <div className="flex flex-wrap justify-center gap-3">
                                    {finalResult.career_suggestions?.map((job, i) => (
                                        <span key={i} className="px-4 py-2 bg-indigo-50 text-indigo-700 rounded-full font-bold text-sm border border-indigo-100">
                                            {job}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="text-center">
                            <button className="back-btn-modern inline-flex px-8 py-3" onClick={() => navigate('/student')}>
                                Về Dashboard
                            </button>
                        </div>
                    </div>
                )}

            </div>

            {/* STYLES (TỐI ƯU HIỆU NĂNG) */}
            <style>{`
                :root {
                    --primary: #DB2777; 
                    --text-main: #1F2937;
                    /* ✅ FIX LAG: Bỏ blur, dùng nền trắng đục */
                    --glass-bg: rgba(255, 255, 255, 0.95);
                    --glass-border: rgba(255, 255, 255, 1);
                }

                .student-page-container {
    width: 100%;
    min-height: 100vh;
    height: auto; /* ✅ Fix lỗi không scroll được khi nội dung dài */
    background: linear-gradient(135deg, #FDF2F8 0%, #EEF2FF 100%);
    font-family: 'Inter', sans-serif;
    position: relative;
    padding: 80px 20px 60px;
    color: var(--text-main);
    overflow-x: hidden;
    overflow-y: visible;
}
                
                /* ✅ FIX LAG: Tối ưu Blob Animation */
                .blob { position: absolute; border-radius: 50%; filter: blur(60px); opacity: 0.4; z-index: 0; will-change: transform; }
                .blob-1 { top: -100px; left: -100px; width: 400px; height: 400px; background: #FBCFE8; animation: floatBlob 20s infinite ease-in-out alternate; }
                .blob-2 { bottom: -100px; right: -100px; width: 500px; height: 500px; background: #C4B5FD; animation: floatBlob 25s infinite ease-in-out alternate-reverse; }
                @keyframes floatBlob { 0% { transform: translate3d(0, 0, 0); } 100% { transform: translate3d(30px, 30px, 0); } }

                .content-wrapper { max-width: 1000px; margin: 0 auto; position: relative; z-index: 10; }
                
                .glass-card {
                    background: var(--glass-bg);
                    border: 1px solid var(--glass-border);
                    border-radius: 24px;
                    box-shadow: 0 10px 40px -10px rgba(0,0,0,0.05); /* Bóng nhẹ */
                }

                /* SLIDER STYLES (Native Scroll Snap - Siêu mượt) */
                .slider-container {
    display: flex;
    gap: 20px;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    padding-bottom: 20px;
    
    /* Ẩn thanh cuộn nhưng vẫn trượt được */
    scrollbar-width: none; 
    -ms-overflow-style: none;
    
    /* ✅ QUAN TRỌNG: Cho phép cuộn trang khi chạm vào slider */
    touch-action: pan-x; 
    -webkit-overflow-scrolling: touch; /* Mượt hơn trên iOS */
}
.slider-container::-webkit-scrollbar { display: none; }

                .slider-card {
                    min-width: 280px;
                    max-width: 280px;
                    padding: 24px;
                    text-align: center;
                    scroll-snap-align: start;
                    cursor: grab;
                    transition: transform 0.2s;
                }
                .slider-card:active { cursor: grabbing; }
                .slider-card:hover { transform: translateY(-5px); }

                /* COMPONENTS */
                .top-nav { position: fixed; top: 90px; left: 20px; z-index: 50; }
                .back-btn-modern {
                    display: flex; align-items: center; gap: 10px;
                    background: white; padding: 8px 16px 8px 8px;
                    border-radius: 30px; border: 1px solid #E5E7EB;
                    box-shadow: 0 4px 15px rgba(0,0,0,0.05);
                    cursor: pointer; color: #4B5563; font-weight: 600;
                    transition: all 0.2s;
                }
                .icon-circle { width: 32px; height: 32px; background: #F3F4F6; border-radius: 50%; display: flex; align-items: center; justify-content: center; transition: background 0.2s; }
                .back-btn-modern:hover .icon-circle { background: #FCE7F3; color: var(--primary); }

                .student-title { font-weight: 900; color: #111827; letter-spacing: -0.02em; }
                .highlight { background: linear-gradient(90deg, #EC4899, #8B5CF6); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
                
                .btn-magic {
                    background: linear-gradient(135deg, #EC4899 0%, #8B5CF6 100%);
                    color: white; font-weight: 800; border-radius: 20px;
                    box-shadow: 0 10px 25px rgba(236, 72, 153, 0.3);
                    transition: all 0.3s;
                }
                .btn-magic:hover { transform: translateY(-4px); box-shadow: 0 20px 40px rgba(236, 72, 153, 0.4); }

                .spinner-lg {
                    width: 50px; height: 50px;
                    border: 4px solid rgba(236, 72, 153, 0.2);
                    border-top-color: #EC4899;
                    border-radius: 50%;
                    animation: spin 1s linear infinite;
                }
                @keyframes spin { to { transform: rotate(360deg); } }
                
                .animate-fade-up { animation: fadeUp 0.6s ease-out; }
                @keyframes fadeUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }

                @media (max-width: 768px) {
                    .back-btn-modern { top: 80px; }
                }
            `}</style>
        </div>
    );
}